import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Testimonial from './components/Testimonial';
import Services from './components/Services';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { SchemaOrg, organizationSchema } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '岡山市の保険代理店 | 家族の未来を守る地域密着型保険相談 | おかやま保険株式会社',
    description: '岡山市・倉敷市・総社市で3,000世帯以上の実績。生命保険・医療保険・自動車保険・火災保険など、あなたのライフステージに最適な保険プランをご提案。',
    url: `${siteUrl}/`,
    publisher: organizationSchema,
  };

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'InsuranceAgency',
    ...organizationSchema,
  };

  return (
    <div className="min-h-screen bg-[#FAF8F3]">
      <SchemaOrg type="WebPage" data={webPageSchema} />
      <SchemaOrg type="Organization" data={localBusinessSchema} />
      <Header />
      <main>
        <Hero />
        <Features />
        <Testimonial />
        <Services />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
